module.exports = __webpack_public_path__ + "static/media/14UNEP12.2ddde5e6.jpg";